import { Button, Divider, Grid, Header, Segment, Table } from "semantic-ui-react";
import { OrgUser_WithFilesAndAssignments } from "../models/OrgUser_WithFilesAndAssignments";
import moment from "moment";
import ServerFileDownloadButton from "./common/ServerFileDownloadButton";
import UserAssignmentsTreeView from "./UserAssignmentsTreeView";
import ViewItem from "./common/ViewItem";

interface Props {
  orgUser?: OrgUser_WithFilesAndAssignments;
  onClose: () => void;
}

const OrgUserView = ({ orgUser, onClose }: Props) => {
  const registerAssignments = orgUser?.registerAssignments;
  return (
    <>
      {orgUser && (
        <>
          <Segment attached="top" basic secondary compact>
            <Button
              circular
              icon="close"
              floated="right"
              style={{ padding: "5px", marginLeft: "8px", boxShadow: "0px 0px" }}
              onClick={onClose}
            ></Button>

            <Header as="h4" style={{ display: "inline" }}>
              {orgUser.user.displayName}
            </Header>
          </Segment>

          <Segment attached color="green" style={{ borderTop: "3px !important" }}>
            <Divider horizontal>User details</Divider>
            <Grid columns="2">
              <Grid.Row>
                <Grid.Column>
                  <ViewItem header="Phone number" value={orgUser.user.phoneNumber || "-"} />
                </Grid.Column>
                <Grid.Column>
                  <ViewItem header="Admin role" value={orgUser.adminRole?.name.replace(/^[^_]*_/, "") || "-"} />
                </Grid.Column>
              </Grid.Row>
            </Grid>

            <Divider horizontal>CAT and Genny</Divider>
            <Grid columns="2">
              <Grid.Row>
                <Grid.Column>
                  <ViewItem header="CAT serial number" value={orgUser.calibrationCertificate?.catSerialNumber || "-"} />
                  <ViewItem
                    header="CAT calibration date"
                    value={orgUser.calibrationCertificate?.catCalibrationDate || "-"}
                  />
                </Grid.Column>
                <Grid.Column>
                  <ViewItem
                    header="CAT calibration date"
                    value={orgUser.calibrationCertificate?.catCalibrationDate || "-"}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <ViewItem
                    header="CAT calibration due date"
                    value={orgUser.calibrationCertificate?.catCalibrationDueDate || "-"}
                  />
                </Grid.Column>
                <Grid.Column>
                  <ViewItem
                    header="Genny serial number"
                    value={orgUser.calibrationCertificate?.gennySerialNumber || "-"}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <ViewItem
                    header="Genny calibration date"
                    value={orgUser.calibrationCertificate?.gennyCalibrationDate || "-"}
                  />
                </Grid.Column>
                <Grid.Column>
                  <ViewItem
                    header="Genny calibration due date"
                    value={orgUser.calibrationCertificate?.gennyCalibrationDueDate || "-"}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>

            <Divider horizontal>Files ({orgUser.orgUserFiles?.length ?? 0})</Divider>
            {orgUser.orgUserFiles && orgUser.orgUserFiles.length > 0 ? (
              <Table basic="very" compact>
                <Table.Body>
                  {orgUser.orgUserFiles.map((file) => (
                    <Table.Row key={file.id}>
                      <Table.Cell>{file.title}</Table.Cell>
                      <Table.Cell>
                        {file.expiryDate ? "Expires on: " + moment(file.expiryDate).format("L") : ""}
                      </Table.Cell>
                      <Table.Cell textAlign="right" style={{ padding: 0 }}>
                        {file.fileUrl && <ServerFileDownloadButton fileUrl={file.fileUrl}></ServerFileDownloadButton>}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            ) : (
              <p>No files found.</p>
            )}
          </Segment>

          <Segment attached basic color="green" style={{ borderTop: "3px !important" }}>
            <Header as="h4" style={{ display: "inline" }}>
              User assignments
            </Header>
            <UserAssignmentsTreeView assignments={registerAssignments ?? []} />
          </Segment>
        </>
      )}{" "}
    </>
  );
};

export default OrgUserView;
